import React from 'react';
import { Button, Card, IconWarning } from '@veneer/core';

const ErrorScreenAddTrialPlan = (props) => {
  let serviceName = localStorage.getItem('service_name');
  let _content = (
    <div>
      <IconWarning size={72} />
      <h5>{L10n.t('service.add.trial.error.line1', { service: serviceName })}</h5>
      <p className='dui-margin-top-8 text-std'>{L10n.t('service.add.trial.error.line2')}</p>
    </div>
  );

  return (
    <React.Fragment>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12 dui-align-center'>
            <Card className='adminx-onboarding-card align-middle' content={_content} />
          </div>
        </div>
        <div className='row'>
          <div className='col-12 vn-button-group--horizontal text-right dui-margin-top-40 dui-margin-bottom-40'>
            <Button
              onClick={() => {
                props.callOnboardingCallBack();
              }}
            >
              {L10n.t('global.next')}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ErrorScreenAddTrialPlan;
